import Chartist from 'chartist'
import { isNull } from 'lodash'

// TODO: Refactor and clean up code. It's a bit messy right now.

const defaultOptions = {
  labelClass: 'ct-point-label font-thin px-sm',
  textAnchor: 'middle',
  align: 'center',
  isInverted: false,
  labelOffset: {
    x: 5,
    y: 4.5
  },
  labelInterpolationFnc: val => val
}

const labelPositionCalculation = {
  point: data => ({ x: data.x, y: data.y }),
  bar: {
    left: data => ({ x: data.x1, y: data.y1 }),
    center: data => ({
      x: data.x1 + (data.x2 - data.x1) / 2,
      y: data.y1
    }),
    right: data => ({ x: data.x2, y: data.y1 })
  }
}

const pointLabels = options => {
  options = Chartist.extend({}, defaultOptions, options)

  const addLabel = (position, data) => {
    const value =
      'x' in data.value && data.value.y
        ? `${data.value.x}, ${data.value.y}`
        : data.value.y || data.value.x

    const interpolated = options.labelInterpolationFnc(value)

    const valueLabel = data.group
      .elem('text', {}, options.labelClass)
      .text(interpolated.value)
      .animate({
        opacity: {
          // Because we are inverting the data for a horizontal chart, the
          // reverse order of animation needs to be set.
          begin: (data.series.length - data.index) * options.animationBegin,
          from: 0,
          to: 1,
          dur: options.animationDuration,
          easing: options.animationEasing
        }
      })
    const percentLabel = data.group
      .elem('text', {}, `${options.labelClass} percent`)
      .text(interpolated.percentage || '')
      .animate({
        opacity: {
          // Because we are inverting the data for a horizontal chart, the
          // reverse order of animation needs to be set.
          begin: (data.series.length - data.index) * options.animationBegin,
          from: 0,
          to: 1,
          dur: options.animationDuration,
          easing: options.animationEasing
        }
      })

    if (!isNull(interpolated.percentage)) {
      valueLabel.attr({
        x: options.isInverted
          ? position.x - percentLabel._node.getBBox().width - 10
          : position.x + options.labelOffset.x,
        y: position.y + options.labelOffset.y,
        style: `text-anchor: ${options.textAnchor}`
      })
      percentLabel.attr({
        x: options.isInverted
          ? position.x - options.labelOffset.x
          : position.x + valueLabel._node.getBBox().width + 10,
        y: position.y + options.labelOffset.y,
        style: `text-anchor: ${options.textAnchor};`,
        fill: '#9B9B9B'
      })
    } else {
      valueLabel.attr({
        x: options.isInverted
          ? position.x - options.labelOffset.x
          : position.x + options.labelOffset.x,
        y: position.y + options.labelOffset.y,
        style: `text-anchor: ${options.textAnchor}`
      })
    }
  }

  const pointLabels = chart => {
    if (chart instanceof Chartist.Line || chart instanceof Chartist.Bar) {
      chart.on('draw', data => {
        const positionCalculator =
          (labelPositionCalculation[data.type] &&
            labelPositionCalculation[data.type][options.align]) ||
          labelPositionCalculation[data.type]

        data.x1 = data.x1 - 500

        if (positionCalculator) {
          addLabel(positionCalculator(data), data)
        }
      })
    }
  }

  return pointLabels
}

export default pointLabels
